<!--
@component
MatchCardGoals

See markup below.
-->

<script lang="ts">
  import type { Card, Goal } from '$lib/@types/opta';
  import Icon from '$lib/components/common/Icons/index.svelte';

  type MatchEvent = Goal | Card;

  type Props = {
    events: MatchEvent[];
  };

  let { events }: Props = $props();

  const isRedCard = (event: MatchEvent) =>
    event.type === 'Y2C' || event.type === 'RC';
</script>

{#if events.length}
  <div class="goals-detail">
    {#each events as event (`${event.timeMin}-${event.type}-${event.playerName ?? event.scorerName ?? ''}`)}
      {#if isRedCard(event)}
        <div class="red-card">
          <span class="icon">
            <Icon name="red-card" width="1rem" height="1rem" />
          </span>
          <span class="time">{event.timeMin}'</span>
          <span class="scorer">{event.playerName || ''}</span>
        </div>
      {:else}
        <div class="goal">
          <div class="icon" class:og={event.type === 'OG'}>
            <Icon name="football" width="1rem" height="1rem" />
          </div>
          <span class="time">{event.timeMin}'</span>
          <span class="scorer">
            {event.scorerName}
            {#if event.type === 'OG'}&nbsp;(OG){/if}
            {#if event.type === 'PG'}&nbsp;(P){/if}
          </span>
        </div>
      {/if}
    {/each}
  </div>
{/if}

<style lang="scss">
  @use '../../../styles/mixins' as mixins;

  .goals-detail {
    .scorer {
      white-space: pre-wrap;
      text-align: left;
    }

    .goal,
    .red-card {
      display: flex;

      @include mixins.text-sm;
      @include mixins.leading-none;
      @include mixins.fmy-2;
      @include mixins.fpx-3;

      @media (max-width: 475px) {
        @include mixins.text-xs;
      }

      .time {
        min-width: 2rem;
        width: auto;
        @include mixins.font-medium;
        @include mixins.fpr-1;

        @media (max-width: 475px) {
          min-width: auto;
        }
      }

      .icon {
        margin-right: 0.15rem;

        :global(img) {
          margin: 0;
        }
      }
    }
  }
</style>
